// extracted by mini-css-extract-plugin
export default {"Container":"Roadmap_Container__wR1Mr","Header":"Roadmap_Header__TZRwJ","Img":"Roadmap_Img__sJUEL","p":"Roadmap_p__8VxcJ","h2":"Roadmap_h2__OY-rg"};